<template>
  <div class="container-fluid">
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Ofertas</h1>
          <p class="view-header__subtitle">Campañas de descuento aplicadas al catálogo</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="openNew">
            <i class="bi bi-plus-lg"></i> Nueva campaña
          </button>
        </div>
      </div>
    </div>

    <table v-if="campaigns.length > 0" class="table table-striped">
      <thead>
        <tr>
          <th>Campaña</th>
          <th>Descuento</th>
          <th>Vigencia</th>
          <th>Canal</th>
          <th class="text-right">Productos</th>
          <th>Estado</th>
          <th class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="campaign in campaigns" :key="campaign.id">
          <td>
            <div>{{ campaign.name }}</div>
            <div class="text-muted small">{{ scopeLabel(campaign) }}</div>
          </td>
          <td>{{ campaign.discount_percent }}% OFF</td>
          <td>
            <div>{{ formatoDate2Fecha(campaign.starts_at) }} {{ campaign.ends_at ? '– ' + formatoDate2Fecha(campaign.ends_at) : '' }}</div>
            <div v-if="campaign.until_stock_out" class="text-warning small">Hasta agotar stock</div>
          </td>
          <td>{{ channelLabel(campaign.channel) }}</td>
          <td class="text-right">{{ campaign.affected_products_count }}</td>
          <td>{{ statusLabel(campaign) }}</td>
          <td class="text-right">
            <button type="button" class="btn btn-sm btn-outline-secondary" title="Editar" @click="openEdit(campaign.id)">
              <i class="bi bi-pencil"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary ml-1"
              :title="campaign.active ? 'Pausar' : 'Activar'"
              @click="toggleActive(campaign)"
            >
              <i :class="campaign.active ? 'bi bi-pause-fill' : 'bi bi-play-fill'"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-danger ml-1" title="Eliminar" @click="deleteCampaign(campaign)">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else class="text-muted">No hay campañas de oferta cargadas todavía.</p>

    <edit-oferta
      v-if="showModal"
      :campaign-id="editingCampaignId"
      @close="closeModal"
      @saved="onSaved"
    />
  </div>
</template>

<script>
import axios from 'axios';
import formatDateMixin from '../../../mixins/formatDateMixin';
import EditOferta from './Edit-oferta.vue';

export default {
  mixins: [formatDateMixin],
  components: { EditOferta },
  data() {
    return {
      campaigns: [],
      showModal: false,
      editingCampaignId: null,
    };
  },
  mounted() {
    this.loadCampaigns();
  },
  methods: {
    loadCampaigns() {
      axios.get('/api/offers/list').then((response) => {
        this.campaigns = response.data.data;
      });
    },
    openNew() {
      this.editingCampaignId = null;
      this.showModal = true;
    },
    openEdit(campaignId) {
      this.editingCampaignId = campaignId;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editingCampaignId = null;
    },
    onSaved() {
      this.closeModal();
      this.loadCampaigns();
    },
    toggleActive(campaign) {
      const payload = {
        name: campaign.name,
        discount_percent: campaign.discount_percent,
        starts_at: campaign.starts_at,
        ends_at: campaign.ends_at,
        until_stock_out: campaign.until_stock_out,
        channel: campaign.channel,
        scope: campaign.scope,
        active: !campaign.active,
        category_ids: (campaign.categories || []).map((c) => c.id),
        product_ids: (campaign.products || []).map((p) => p.id),
      };
      axios.post('/api/offers/edit/' + campaign.id, payload).then(() => {
        this.loadCampaigns();
      }).catch(() => {
        alert('No se pudo cambiar el estado de la campaña.');
      });
    },
    async deleteCampaign(campaign) {
      const confirmed = await this.$confirm(
        '¿Seguro que querés eliminar "' + campaign.name + '"? Esta acción no se puede deshacer.',
        { title: 'Eliminar campaña', okText: 'Eliminar', variant: 'danger' },
      );
      if (!confirmed) return;
      axios.post('/api/offers/delete/' + campaign.id).then(() => {
        this.loadCampaigns();
      }).catch(() => {
        alert('No se pudo eliminar la campaña.');
      });
    },
    scopeLabel(campaign) {
      if (campaign.scope === 'all') return 'Todo el catálogo';
      if (campaign.scope === 'category') return 'Categorías: ' + (campaign.categories || []).map((c) => c.name).join(', ');
      return 'Productos sueltos (' + (campaign.products || []).length + ')';
    },
    channelLabel(channel) {
      if (channel === 'pos') return 'Solo mostrador';
      if (channel === 'online') return 'Solo tienda online';
      return 'Ambos canales';
    },
    statusLabel(campaign) {
      if (!campaign.active) return 'Dada de baja';
      const today = new Date().toISOString().slice(0, 10);
      if (campaign.starts_at > today) return 'Programada';
      if (campaign.ends_at && campaign.ends_at < today) return 'Vencida';
      return 'Activa';
    },
  },
};
</script>
